export default __webpack_public_path__ + "static/media/VK.9f7c4d68.svg";